import React from 'react';
import styles from './loader-styles.css';

export default function LoadingSpinner(){

    return(
        <div className={styles["spinner"]}>
            <div className={styles["dot1"]}></div>
            <div className={styles["dot2"]}></div>
        </div>
    )
}
